import { ThemeProvider } from '@mui/material/styles';
import React, { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { EventBusProvider } from 'utils/EventBus';

import { ProtectedRoutes } from 'hoc/ProtectedRoutes';

import { ROUTES } from 'core/constants/routes';
import { PaymentStatus } from 'core/enums/common';

import Home from 'pages/Home';
import { Login } from 'pages/Login/Login';
import { ResetPassword } from 'pages/ResetPassword/ResetPassword';
import { SignUp } from 'pages/SignUp/SignUp';

import { PaymentResultPage } from 'components/Payment/PaymentResultPage';
import { UpdateMethodResult } from 'components/Profile/Subscription/UpdatePaymentInformation/UpdateMethodResult';

import './App.scss';
import { theme } from './assets/styles/_theme';

const App: React.FC = () => {
	const { i18n } = useTranslation();

	useEffect(() => {
		document.body.classList.toggle('rtl', i18n.language === 'ar');
	}, [i18n.language]);

	return (
		<ThemeProvider theme={theme}>
			<Suspense fallback={<div>Loading...</div>}>
				<EventBusProvider>
					<Routes>
						<Route path={ROUTES.LOGIN} element={<Login />} />
						<Route path={ROUTES.SIGNUP} element={<SignUp />} />
						<Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
						<Route path={ROUTES.CREATE_NEW_PASSWORD} element={<ResetPassword />} />
						<Route element={<ProtectedRoutes />}>
							<Route path={ROUTES.HOME} element={<Home />} />
							<Route
								path={ROUTES.PAYMENT_SUCCESS}
								element={<PaymentResultPage status={PaymentStatus.success} />}
							/>
							<Route
								path={ROUTES.PAYMENT_CANCEL}
								element={<PaymentResultPage status={PaymentStatus.cancel} />}
							/>
							<Route
								path={ROUTES.METHOD_SUCCESS}
								element={<UpdateMethodResult status={PaymentStatus.success} />}
							/>
							<Route
								path={ROUTES.METHOD_CANCEL}
								element={<UpdateMethodResult status={PaymentStatus.cancel} />}
							/>
						</Route>
					</Routes>

					<ToastContainer
						style={{
							width: window.innerWidth <= 600 ? '300px' : '400px',
							maxWidth: 'fit-content',
						}}
					/>
				</EventBusProvider>
			</Suspense>
		</ThemeProvider>
	);
};

export default App;
